// import { IconButton, Badge } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";

export default function NotificationButton({ count }) {
	return (
		<IconButton color="inherit">
			<Badge badgeContent={count} color="error">
				<NotificationsIcon />
			</Badge>
		</IconButton>
	);
}
